import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { select, Store } from '@ngrx/store';
import { Select2Data, Select2UpdateEvent, Select2Value } from 'ng-select2-component';
import { ToastrService } from 'ngx-toastr';
import { ApiResponse } from 'src/app/shareModule/models/common.model';
import { AuthServiceService } from 'src/app/shareModule/services/auth-service.service';
import { CommonService } from 'src/app/shareModule/services/common.service';
import { AppState } from 'src/app/shareModule/states/app.state';
import { selectAllCommunityProductCategory } from 'src/app/shareModule/states/community-product-category';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-member-news',
  templateUrl: './member-news.component.html',
  styleUrls: ['./member-news.component.scss']
})
export class MemberNewsComponent implements OnInit {


  @ViewChild("AssignOption") AssignOptionModal: ElementRef;
  @ViewChild("AddNews") addEventModal: ElementRef;

  @Input() hideAll: boolean = false;

  public editMode: boolean;
  public commonModal: any;
  public allNews: Array<any> = [];
  public selectedAds: any;
  public imageBase64: string | ArrayBuffer;
  public imgUrl = environment.ImageUrl;

  public categoriesList: Array<any> = [];
  public subRegionList: Array<any> = [];
  public selectedArticle: any = null;
  public categoryDropdown: Select2Data = [];
  public categorySelectedDropdown: Array<any> = [];

  public regionDropdown: Select2Data = [];
  public regionSelectedDropdown: Array<any> = [];

  public form: FormGroup = new FormGroup({
    news: new FormControl("", [Validators.required]),
    url: new FormControl("", [Validators.required]),
    author: new FormControl("", [Validators.required]),
    category: new FormControl("", [Validators.required]),
    image: new FormControl(null, [Validators.required]),
  });


  constructor(
    private store: Store<AppState>,
    private toastr: ToastrService,
    private modalService: NgbModal,
    private auth: AuthServiceService,
    public commonService: CommonService) { }

  ngOnInit(): void {
    this._getAdsList();
    this._getAllMemberShopCategoriesList();
  }

  public openProductCharForAddEdit(selected: any = null) {
    if (selected) {
      this.editMode = true;
      this.selectedAds = selected;
      this.form.patchValue({
        news: selected?.text,
        url: selected?.url,
        image: selected?.image,
        author: selected?.author,
        category: selected?.category,
      });
    } else {
      this.form.reset();
      this.imageBase64 = null;
      this.selectedAds = null;
      this.selectedArticle = null;
    }
    this.commonModal = this.modalService.open(this.addEventModal, {
      size: "xs",
      backdrop: "static",
      windowClass: "suggestion",
    });
  }

  public saveProductCharSelectedImage(event) {
    this.selectedAds ? (this.selectedAds.image = null) : "";
    let file = event.target.files[0];
    let fileReader = new FileReader();
    fileReader.onload = () => {
      this.imageBase64 = fileReader.result;
      this.form.get("image").setValue(file);
    };
    fileReader.readAsDataURL(file);
  }

  public modalDismissAll() {
    this.modalService.dismissAll();
    this.selectedAds = null;
  }

  public save(): void {
    if (this.form.valid) {
      let formData = new FormData();
      typeof this.form.get("image").value == "string" ? "" : formData.append("image", this.form.get("image").value);

      formData.append("text", this.form.get("news").value);
      formData.append("url", this.form.get("url").value);
      formData.append("author", this.form.get("author").value);
      formData.append("category", this.form.get("category").value);

      // formData.append("subRegion", 'default');

      if (this.selectedAds) {
        formData.append("id", this.selectedAds?.id);
      }
      this.auth.addNews(formData).subscribe((resp: ApiResponse) => {
        this.toastr.success(resp.message);
        this.modalDismissAll();
        this._getAdsList();
        this.selectedAds = null;
      }, ({ error }: any) => {
        this.toastr.error(error.message);
      });
    } else {
      this.toastr.error("Form is Invalid fill ALL ");
    }
  }

  private _getAdsList() {
    this.auth.getAllNews().subscribe((resp: ApiResponse) => {
      let output = [];
      for (let i of resp.body) {
        output.push({ ...i, ...{ categoryList: (i.memberShopCategory && i.memberShopCategory.includes('|') ? i.memberShopCategory.split('|') : [i.memberShopCategory]), subRegionList: (i.memberShopSubRegion && i.memberShopSubRegion.includes('|') ? i.memberShopSubRegion.split('|') : [i.memberShopSubRegion]) } });
      }
      this.allNews = output;
    });
  }

  public deleteAds(id) {
    this.auth.deleteNews(id).subscribe((resp: ApiResponse) => {
      this.toastr.success(resp.message);
      this._getAdsList();
    });
  }

  public assign(selectedArticle) {
    // this.categoriesList = this.categoriesList.map((i: any) => {
    //   let output = i;
    //   output['checked'] = selectedArticle.memberShopCategory ?  : false;
    //   return output;
    // });

    this.categoryDropdown = this.categoriesList.map((i: any) => {
      return { value: i.name, label: i.name }
    });

    this.categoryDropdown.unshift({ value: 'all', label: 'Select All' });

    this.categorySelectedDropdown = this.categoryDropdown.filter((i: any) => {
      if (selectedArticle.memberShopCategory && selectedArticle.memberShopCategory.includes(i.value ? i.value : '')) {
        return true;
      } else {
        return false;
      }
    }).map((i: any) => i.value);


    this.regionDropdown = structuredClone(this.commonService.subRegionLists.map((j) => {
      return { value: j.name, label: j.name };
    }));

    this.regionDropdown.unshift({ value: 'all', label: 'Select All' });


    this.regionSelectedDropdown = this.regionDropdown.filter((i: any) => {
      if (selectedArticle.memberShopSubRegion && selectedArticle.memberShopSubRegion.includes(i.value ? i.value : '')) {
        return true;
      } else {
        return false;
      }
    }).map((i: any) => i.value);



    this.selectedArticle = selectedArticle;
    this.commonModal = this.modalService.open(this.AssignOptionModal, { size: 'sm', ariaLabelledBy: 'modal-basic-title' })
  }

  private _getAllMemberShopCategoriesList(): void {
    this.store
      .pipe(select(selectAllCommunityProductCategory))
      .subscribe((list: any) => {
        let response = structuredClone(list);
        let output = response.map(i => {
          let output = i;
          output['checked'] = false;
          return output;
        });
        this.categoriesList = this.commonService.removeDuplicateAndCombineByProp(output, 'name');
      });
  }

  update(event: Select2UpdateEvent<any>) {
    if (event.value[event.value.length - 1] == 'all' && this.categorySelectedDropdown.length != event.value.length) {
      this.categorySelectedDropdown = this.categoryDropdown.map((i: any) => i.value);
    } else {
      this.categorySelectedDropdown = event.value;
    }

  }

  updateRegion(event: Select2UpdateEvent<any>) {
    if (event.value[event.value.length - 1] == 'all' && this.regionSelectedDropdown.length != event.value.length) {
      this.regionSelectedDropdown = this.regionDropdown.map((i: any) => i.value);
    } else {
      this.regionSelectedDropdown = event.value;
    }

  }

  assignArticles() {
    if (this.selectedArticle) {
      let categoryStr = this.categorySelectedDropdown.join('|');
      let subRegionStr = this.regionSelectedDropdown.join('|');
      this.auth.assignArticles({ id: this.selectedArticle.id, memberShopCategory: categoryStr, memberShopSubRegion: subRegionStr }).subscribe((resp: ApiResponse) => {
        this.toastr.success(resp.message);
        this.commonModal ? this.commonModal.close() : '';
        this._getAdsList();
      })
    } else {
      this.toastr.error('Invalid Id!');
    }
  }

}
